import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../../shared/services/security/auth.service';

  @Injectable()
  export class RoleGuard implements CanActivate {
    constructor(private readonly auth: AuthService, public router: Router) {}
    canActivate(route: ActivatedRouteSnapshot): boolean {

      const expectedRoles = route.data.expectedRoles;
      const roleUser = this.auth.getUserRol();

      if (!expectedRoles.includes(roleUser)) {
        this.router.navigate(['leads']);
        return false;
      }
      return true;
    }
  }